<template>
  <div v-if="active" class="overlay-wrapper-container">
    <div class="overlay">
      <scale-loader :loading="true" height="50px" width="15px" />
    </div>
  </div>
</template>

<script>
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default {
  name: "OverlayProgress",
  components: {
    ScaleLoader
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.overlay-wrapper-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  .overlay {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 5;
    opacity: 0.5;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background-color: lightgrey;
  }
}
</style>
